import { useCallback, useState, memo } from 'react';
import { animateScroll as scroll } from 'react-scroll';
import { useVisibility } from '@/hooks';
import clsx from 'clsx';
import styles from './ScrollBtn.module.scss';

const ScrollBtn = memo(({ isWishlist = false }) => {
	const [triggerRef, setTriggerRef] = useState();
	const { visible } = useVisibility(triggerRef);

	const onClick = useCallback(() => {
		scroll.scrollToTop();
	}, []);

	return (
		<>
			<button
				className={clsx(
					styles.scrollButton,
					visible && styles.scrollButtonVisible,
					isWishlist && styles.wishlistStyle,
				)}
				onClick={onClick}
			/>
			<div className={styles.trigger} ref={setTriggerRef} />
		</>
	);
});

export default ScrollBtn;
